import OnboardingPictureForm from './OnboardingPictureForm';
export default OnboardingPictureForm;
